import script from "./noticeInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeInfoList.vue?vue&type=script&setup=true&lang=js"

import "./noticeInfoList.vue?vue&type=style&index=0&id=3cb0837a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb0837a"]])

export default __exports__